/**
 * Какие ошибки отправлять в Sentry (BPSD-7391).
 *
 * Ошибки браузерных расширений и MetaMask к порталу не относятся.
 * HTTP-ошибки клиента (0, 4xx) — штатные ответы или сбой сети, их показывает
 * ErrorsHandlerService тостом; в Sentry уходят только 5xx.
 * ChunkLoadError после деплоя обрабатывается перезагрузкой страницы
 * (app.component.ts, NavigationError).
 */
export const SENTRY_DENY_URLS: RegExp[] = [
  /^chrome-extension:\/\//i,
  /^moz-extension:\/\//i,
  /^safari(-web)?-extension:\/\//i,
];

export const SENTRY_IGNORE_ERRORS: RegExp[] = [/MetaMask/i];

const CHUNK_LOAD_ERROR =
  /Loading chunk [\w-]+ failed|Loading CSS chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i;

export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const { name, message } = error as { name?: unknown; message?: unknown };
  return (
    name === 'ChunkLoadError' ||
    (typeof message === 'string' && CHUNK_LOAD_ERROR.test(message))
  );
}

export function isReportableHttpStatus(status: number): boolean {
  return status >= 500;
}

/** Сегмент пути, в котором есть цифра, кроме версии API (`v1`, `v2`). */
const ID_SEGMENT = /\/(?!v\d+(?=\/|$))[^/]*\d[^/]*(?=\/|$)/g;

/**
 * Путь запроса для fingerprint 5xx: без хоста и query, сегменты с цифрами
 * (id, UUID, трек-номера, коды) заменены на `:id`, версия API сохраняется.
 *
 * `/api/v2/tracking/RR123456789BY?lang=ru` → `/api/v2/tracking/:id`
 * `/api/v2/batch-mailing/<uuid>/item/42` → `/api/v2/batch-mailing/:id/item/:id`
 */
export function normalizeUrlPath(url: string | null): string {
  if (!url) {
    return 'unknown';
  }
  const path = url.split('?')[0].replace(/^https?:\/\/[^/]+/, '');
  return path.replace(ID_SEGMENT, '/:id');
}
